var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 359,
    viewBox: "0 0 321 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1654_13378",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: 0,
    width: 360,
    height: 360
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-39 0H321V360H-39V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1654_13378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.612 315.125C214.323 300.86 201.015 276.543 201.015 250.079V230.902L243.374 213.958L285.734 230.902V250.079C285.734 276.543 272.427 300.86 250.136 315.125L243.374 319.453L236.612 315.125Z",
    fill: "#2B195B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4484 200.454C0.635159 205.151 -12.7594 215.466 -21.4219 229.085L31.5656 310.605H88.0406L16.4484 200.454Z",
    fill: "#2B195B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8643 172.367V197.668C66.8643 209.365 76.3466 218.848 88.0445 218.848C99.7417 218.848 109.224 209.365 109.224 197.668V172.367",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.353 7.0357C111.656 7.0357 102.173 16.518 102.173 28.2159C102.173 16.518 92.6906 7.0357 80.9934 7.0357H3.33398V42.3354C3.33398 54.0326 12.8163 63.5156 24.5142 63.5156H102.173H144.533V28.2159C144.533 16.518 135.05 7.0357 123.353 7.0357Z",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2853 176.484H87.8262C56.76 176.484 31.5762 151.301 31.5762 120.234V63.5252H144.535V120.234C144.535 151.301 119.351 176.484 88.2853 176.484Z",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9248 127.031H102.164",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.9688 310.609H88.0505C111.445 310.609 130.41 329.574 130.41 352.969H3.33093",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0459 310.609V352.969",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5762 310.609V352.969",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.242 264.742L239.832 275.332L261.012 254.152",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53 209.473C167.646 202.02 154.479 197.658 140.291 197.658H109.228",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8702 197.65H35.8062C-1.62469 197.65 -31.9688 227.994 -31.9688 265.425V352.969H208.069V328.807",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.357 338.899L243.372 352.969L221.387 338.899C191.097 319.513 172.772 286.029 172.772 250.067V211.77L243.372 183.53L313.972 211.77V250.067C313.972 286.029 295.647 319.513 265.357 338.899Z",
    stroke: "#2B195B",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpa);
export default __webpack_public_path__ + "static/media/gpa.199c52fe52509d100bfe7f98005727e0.svg";
export { ForwardRef as ReactComponent };